export default __webpack_public_path__ + "static/media/arrow-slide-right.25f3a34d.svg";